import Cookies from 'js-cookie'

export const getAllCookies = () => {
    const authToken = Cookies.get("JWT_TOKEN") || "";
    return { authToken };
};

export const getFormattedDate = (date, year) => {
    return `${date.replace("/", "-")}-${year}`;
}